(() => {
  const configNode = document.getElementById('volu-config');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const form = document.getElementById('volu-product-form');
  if (!form) return;
  const button = document.getElementById('purchase');
  const addon = document.getElementById('add-shampoo');
  const radios = [...document.querySelectorAll('input[name="size"]')];
  const error = document.getElementById('cart-error');
  let variant = config.variants.find(v => v.id === config.selectedId) || config.variants[0];
  let busy = false;
  const money = cents => new Intl.NumberFormat('zh-HK', {style:'currency', currency:config.currency, minimumFractionDigits:cents % 100 ? 2 : 0, maximumFractionDigits:2}).format(cents / 100);
  const setText = (selector, value) => document.querySelectorAll(selector).forEach(el => { el.textContent = value; });
  const paired = () => Boolean(config.kind === 'mist' && addon?.checked && config.offerEligible && config.addon?.available && variant.available);
  function update() {
    const pair = paired();
    const subtotal = variant.price + (pair ? config.addon.price : 0);
    const total = subtotal - (pair ? config.discount : 0);
    document.getElementById('variant-id').value = variant.id;
    radios.forEach(radio => { radio.checked = String(variant.id) === radio.value; });
    setText('#cart-total, .purchase-total, #sticky-total', money(total));
    setText('#cart-subtotal', money(subtotal));
    setText('#cart-discount', '− ' + money(pair ? config.discount : 0));
    setText('#cart-count', pair ? config.labels.two_items : config.labels.one_item);
    setText('#purchase-label', busy ? config.labels.busy : !variant.available ? config.labels.sold_out : pair ? config.labels.add_pair : config.labels.add_one);
    button.disabled = busy || !variant.available;
    button.setAttribute('aria-busy', String(busy));
    ['summary-extra','summary-discount'].forEach(id => { const el = document.getElementById(id); if(el) el.hidden = !pair; });
    if (addon) addon.disabled = busy || !config.offerEligible || !config.addon?.available || !variant.available;
    document.querySelectorAll('[data-select-duo]').forEach(el => { el.disabled = !config.addon?.available || !variant.available || busy; });
    radios.forEach(radio => { radio.disabled = busy; });
    if (config.kind === 'shampoo') {
      setText('#selected-size', variant.title);
      setText('#sticky-description', config.labels.shampoo + ' · ' + variant.title);
      const im = document.getElementById('selected-product-image');
      if (im && config.scenes[String(variant.id)]) {
        im.src = config.scenes[String(variant.id)];
        im.removeAttribute('srcset');
        im.alt = config.labels.shampoo + ' ' + variant.title;
      }
    } else setText('#sticky-description', pair ? config.labels.mist_pair : config.labels.mist_single);
  }
  radios.forEach(radio => radio.addEventListener('change', () => {
    const next = config.variants.find(v => String(v.id) === radio.value);
    if (!next) return;
    variant = next;
    error.hidden = true;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
    update();
  }));
  addon?.addEventListener('change', update);
  document.querySelectorAll('[data-select-duo]').forEach(el => el.addEventListener('click', () => {
    if (!addon || addon.disabled) return;
    addon.checked = true;
    update();
    document.getElementById('shop').scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    addon.focus({preventScroll:true});
  }));
  async function addItems() {
    if (busy || !variant.available) return;
    const items = [{id:variant.id, quantity:1}];
    if (paired()) items.push({id:config.addon.id, quantity:1});
    busy = true;
    error.hidden = true;
    update();
    try {
      const response = await fetch(config.root + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items})});
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || config.labels.stock_error);
      window.location.assign(config.root + 'cart');
    } catch (reason) {
      busy = false;
      error.textContent = reason.message === 'Failed to fetch' ? config.labels.error : reason.message || config.labels.error;
      error.hidden = false;
      update();
      error.focus();
    }
  }
  window.addEventListener('click', event => {
    if (!event.target.closest('#purchase')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    addItems();
  }, true);
  window.addEventListener('submit', event => {
    if (event.target !== form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    addItems();
  }, true);
  update();
  const sticky = document.querySelector('.sticky-buy');
  const hero = document.querySelector('.hero');
  if (sticky && hero && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => { sticky.classList.toggle('visible', !entries[0].isIntersecting); }, {threshold:0});
    observer.observe(hero);
  }
})();
